import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";
import "./index.css";
import api from "../../api";

function Portal() {
  const [isLoading, setIsLoading] = useState(false);

  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedWard, setSelectedWard] = useState(null);
  const [addressNumber, setAddressNumber] = useState("");
  const [streetName, setStreetName] = useState("");
  const [selectedStoreFormat, setSelectedStoreFormat] = useState(null);
  const [area, setArea] = useState("");
  const [selectedFloorCount, setSelectedFloorCount] = useState({
    label: 1,
    value: 1,
  });
  const [facadeLength, setFacadeLength] = useState("");
  const [initialLeaseRate, setInitialLeaseRate] = useState("");
  const [selectedContactRole, setSelectedContactRole] = useState({
    label: "Chủ nhà",
    value: "host",
  });
  const [selectedPhotos, setSelectedPhotos] = useState({});
  const [contactName, setContactName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [description, setDescription] = useState("");

  const [sendData, setSendData] = useState({
    floor_count: 1,
    contact_role: "host",
    brand_id: 1,
    country_id: 1,
    status: "new",
  });

  const [cityList, setCityList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [wardList, setWardtList] = useState([]);
  const [storeFormatList, setStoreFormatList] = useState([]);
  const [contactRoleList, setContactRoleList] = useState([
    {
      label: "Chủ nhà",
      value: "host",
    },
    {
      label: "Người môi giới",
      value: "real-estate-agent",
    },
  ]);
  const [floorCountList, setFloorCountList] = useState([
    {
      label: 1,
      value: 1,
    },
    {
      label: 2,
      value: 2,
    },
    {
      label: 3,
      value: 3,
    },
    {
      label: 4,
      value: 4,
    },
    {
      label: 5,
      value: 5,
    },
  ]);

  const [imageAttributeList, setImageAttributeList] = useState([
    {
      label: "Hình ảnh mặt tiền",
      value: "photo",
    },
    {
      label: "Hình ảnh bên trái",
      value: "left_angle_photo",
    },
    {
      label: "Hình ảnh bên phải",
      value: "right_angle_photo",
    },
  ]);

  const [error, setError] = useState(false);

  const getCityList = () => {
    api.fetchAPI({
      method: "get",
      uri: `city/`,
      success: (response) => {
        if (response.result) {
          console.log(response);
          var cities = [];
          var i = 2;
          response.result.forEach((item) => {
            if (item.id === 29) {
              cities[0] = {
                label: item.name,
                value: item,
              };
            } else if (item.id == 24) {
              cities[1] = {
                label: item.name,
                value: item,
              };
            } else {
              cities[i] = {
                label: item.name,
                value: item,
              };
              i++;
            }
          });
          setCityList(cities);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  };

  const getDistrictListByCityId = (cityId) => {
    api.fetchAPI({
      method: "get",
      uri: `district/?q=(filters:!((col:city,opr:rel_o_m,value:${cityId})))`,
      success: (response) => {
        if (response.result) {
          if (cityId === 29) {
            var i = 0;
            var j = 10;
            var districts = [];
            var numDistricts = [];
            var sortedNumDistrict = [];
            var strDistricts = [];
            response.result.forEach((item) => {
              if (
                item.name.includes("Quận") &&
                item.name.split(" ").length === 2
              ) {
                if (item.name.split(" ")[1] >= 10) {
                  numDistricts[j] = {
                    label: item.name,
                    value: item,
                  };
                  j++;
                } else {
                  numDistricts[i] = {
                    label: item.name,
                    value: item,
                  };
                  i++;
                }
              } else if (item.name.includes("Quận")) {
                strDistricts.push({
                  label: item.name,
                  value: item,
                });
              } else {
                districts.push({
                  label: item.name,
                  value: item,
                });
              }
            });
            setDistrictList([...numDistricts, ...strDistricts, ...districts]);
          } else {
            setDistrictList(
              response.result.map((item) => {
                return {
                  label: item.name,
                  value: item,
                };
              })
            );
          }
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  };

  const getWardListByDistrictId = (districtId) => {
    api.fetchAPI({
      method: "get",
      uri: `ward/?q=(filters:!((col:district,opr:rel_o_m,value:${districtId})))`,
      success: (response) => {
        if (response.result) {
          setWardtList(
            response.result.map((item) => {
              return {
                label: item.name,
                value: item,
              };
            })
          );
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  };

  const getStoreFomatList = () => {
    api.fetchAPI({
      method: "get",
      uri: `store_format/`,
      success: (response) => {
        if (response.result) {
          setStoreFormatList(
            response.result.map((item) => {
              var label = "";
              if (item.name === "Standalone") {
                label = "Nhà phố";
              } else if (item.name === "In-building") {
                label = "Trong toà nhà / chung cư";
              }
              
              return {
                label,
                value: item,
              };
            })
          );
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  };

  const uploadImage = async (external_site_id) => {
    const promiseAll = [];
    Object.keys(selectedPhotos).forEach(async (photoAttribute, index) => {
      const submitData = new FormData();
      submitData.set("user_file", selectedPhotos[photoAttribute]);
      promiseAll.push(
        api.fetchAPI({
          method: "post",
          body: submitData,
          uri: `externalsitefiles/${external_site_id}/photo_upload/${photoAttribute}`,
          success: (response) => {
            console.log(response);
          },
        })
      );
    });
    await Promise.all(promiseAll);
  };

  const onSendPress = async () => {
    setIsLoading(true);
    if (
      !selectedCity ||
      !selectedDistrict ||
      !selectedWard ||
      addressNumber === "" ||
      streetName === "" ||
      !selectedStoreFormat ||
      area === "" ||
      facadeLength === "" ||
      initialLeaseRate === "" ||
      contactName === "" ||
      contactPhone === "" ||
      !selectedPhotos["photo"]
    ) {
      setError(true);
      setIsLoading(false);
      return;
    }
    var updateData = {
      country_id: 1,
      brand_id: 1,
      city_id: selectedCity.value.id,
      district_id: selectedDistrict.value.id,
      ward_id: selectedWard.value.id,
      address_number: addressNumber,
      street_name: streetName,
      store_format_id: selectedStoreFormat.value.id,
      area: area,
      floor_count: selectedFloorCount.value,
      facade_length: facadeLength,
      initial_lease_rate: initialLeaseRate,
      contact_role: selectedContactRole.value,
      contact_name: contactName,
      contact_phone: contactPhone,
      contact_email: contactEmail,
      description,
    };
    console.log(updateData);
    var full_address = `${updateData.address_number} ${updateData.street_name}, ${selectedWard.value.name}, ${selectedDistrict.value.name}, ${selectedCity.value.name}`;
    api.fetchAPI({
      method: "get",
      uri: `location/geocoding/address_to_lat_lng?address=${full_address}`,
      success: (response) => {
        updateData["latitude"] = response.result.latitude;
        updateData["longitude"] = response.result.longitude;
        console.log(updateData);
        api.fetchAPI({
          method: "post",
          uri: "external_site/external",
          body: updateData,
          success: async (response) => {
            console.log(response);
            if (response.result) {
              const external_site_id = response.result.external_site_id;
              // Upload photos, if any
              if (selectedPhotos) {
                // alert("Đang upload hình ảnh, vui lòng đợi trong giây lát");
                await uploadImage(external_site_id).then(() => {
                  setIsLoading(false);
                  window.location = `/portal_success`;
                });
              } else {
                setIsLoading(false);
                window.location = `/portal_success`;
              }
            }
          },
          error: (error) => {
            setIsLoading(false);
            alert(error.msg);
          },
        });
      },
      error: (response) => {
        setIsLoading(false);
        alert("Error: " + response.msg);
      },
    });
  };

  useEffect(() => {
    getCityList();
    getStoreFomatList();
  }, []);

  const onPhotoSelected = (event, imageAttribute) => {
    setSelectedPhotos({
      ...selectedPhotos,
      ...{ [imageAttribute]: event.target.files[0] },
    });
  };

  const onPhotoRemoved = (imageAttribute) => {
    delete selectedPhotos[imageAttribute];
    setSelectedPhotos({ ...selectedPhotos });
  };

  const checkNumberOfCharacter = (string, character) => {
    var i = 0;
    string.split("").forEach((c) => {
      if (c === character) {
        i++;
      }
    });
    return i;
  };

  console.log(selectedPhotos);

  return (
    <Container>
      <div className="portal-container">
        <Row>
          <Col sm="12" md={{ size: 8, offset: 2 }}>
            <h2 style={{ textAlign: "center", color: "#ea8024" }}>
              Hãy cho chúng tôi biết về mặt bằng của bạn
            </h2>
          </Col>
        </Row>
        <div className="portal-section">
          <h2 className="portal-section-title">Địa chỉ mặt bằng</h2>
          <br />
          <Row>
            <Col xs={12} sm={6}>
              <label>Tỉnh / Thành phố</label>
              <Select
                value={selectedCity}
                options={cityList}
                onChange={(selectedOption) => {
                  setSelectedCity(selectedOption);
                  setSelectedDistrict(null);
                  setSelectedWard(null);
                  getDistrictListByCityId(selectedOption.value.id);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && !selectedCity
                  ? "Bạn vui lòng chọn Tỉnh / Thành phố"
                  : ""}
              </label>
            </Col>
            <Col xs={12} sm={6}>
              <label>Quận / Huyện</label>
              <Select
                options={districtList}
                value={selectedDistrict}
                onChange={(selectedOption) => {
                  setSelectedDistrict(selectedOption);
                  setSelectedWard(null);
                  getWardListByDistrictId(selectedOption.value.id);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && !selectedDistrict
                  ? "Bạn vui lòng chọn Quận / Huyện"
                  : ""}
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              {/* <label>Phường / Xã</label>
              <Input
                value={wardName}
                onChange={e => {
                  setWardName(e.target.value);
                }}
              />

              <label style={{ color: "red", marginTop: 5 }}>
                {error && wardName === ""
                  ? "Bạn vui lòng nhập Phường / Xã"
                  : ""}
              </label> */}
              <label>Phường / Xã</label>
              <Select
                options={wardList}
                value={selectedWard}
                onChange={(selectedOption) => {
                  setSelectedWard(selectedOption);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && !selectedWard
                  ? "Bạn vui lòng chọn Phường / Xã"
                  : ""}
              </label>
            </Col>
            <Col xs={12} sm={6}>
              <label>Số nhà</label>
              <Input
                value={addressNumber}
                onChange={(e) => {
                  setAddressNumber(e.target.value);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && addressNumber === ""
                  ? "Bạn vui lòng nhập Số nhà"
                  : ""}
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <label>Tên đường</label>
              <Input
                value={streetName}
                onChange={(e) => {
                  setStreetName(e.target.value);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && streetName === ""
                  ? "Bạn vui lòng nhập Tên đường"
                  : ""}
              </label>
            </Col>
          </Row>
        </div>
        <div className="portal-section">
          <h2 className="portal-section-title">Thông tin mặt bằng</h2>
          <br />
          <Row>
            <Col xs={12} sm={6}>
              <label>Loại mặt bằng</label>
              <Select
                value={selectedStoreFormat}
                options={storeFormatList}
                onChange={(selectedOption) => {
                  setSelectedStoreFormat(selectedOption);
                }}
              />

              <label style={{ color: "red", marginTop: 5 }}>
                {error && !selectedStoreFormat
                  ? "Bạn vui lòng chọn Loại mặt bằng"
                  : ""}
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <label>Diện tích sử dụng (m2)</label>
              <Input
                value={area}
                onChange={(e) => {
                  if (checkNumberOfCharacter(e.target.value, ".") >= 2) {
                    return;
                  } else {
                    setArea(e.target.value.replace(/[^0-9|.]/g, ""));
                  }
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && area === ""
                  ? "Bạn vui lòng nhập Diện tích sử dụng"
                  : ""}
              </label>
            </Col>
            <Col xs={12} sm={6}>
              <label>Số tầng</label>
              <Select
                options={floorCountList}
                value={selectedFloorCount}
                onChange={(selectedOption) => {
                  setSelectedFloorCount(selectedOption);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && !selectedFloorCount
                  ? "Bạn vui lòng chọn Số tầng"
                  : ""}
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <label>Chiều ngang mặt tiền (m)</label>
              <Input
                value={facadeLength}
                onChange={(e) => {
                  if (checkNumberOfCharacter(e.target.value, ".") >= 2) {
                    return;
                  } else {
                    setFacadeLength(e.target.value.replace(/[^0-9|.]/g, ""));
                  }
                }}
              />

              <label style={{ color: "red", marginTop: 5 }}>
                {error && facadeLength === ""
                  ? "Bạn vui lòng nhập Chiều ngang mặt tiền"
                  : ""}
              </label>
            </Col>
            <Col xs={12} sm={6}>
              <label>Giá đề nghị (VND / tháng)</label>
              <Input
                value={
                  initialLeaseRate === ""
                    ? ""
                    : parseInt(initialLeaseRate).toLocaleString()
                }
                onChange={(e) => {
                  setInitialLeaseRate(e.target.value.replace(/\D/g, ""));
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && initialLeaseRate === ""
                  ? "Bạn vui lòng nhập Giá đề nghị"
                  : ""}
              </label>
            </Col>
          </Row>
          <Row>
            {imageAttributeList.map((item) => (
              <Col xs={12} sm={6} key={item.value}>
                <FormGroup>
                  <Label>{item.label}</Label>
                  <br />
                  <Button
                    style={{ marginBottom: 5 }}
                    outline
                    color="primary"
                    size="sm"
                  >
                    <input
                      accept="image/*"
                      type="file"
                      name="file"
                      id={`file-${item.value}`}
                      className="inputfile"
                      onChange={(event) => onPhotoSelected(event, item.value)}
                    />
                    <label
                      style={{ marginBottom: 0 }}
                      htmlFor={`file-${item.value}`}
                    >
                      Chọn ảnh để tải lên
                    </label>
                  </Button>
                  {selectedPhotos[item.value] && (
                    <Button
                      style={{ marginLeft: 5, marginBottom: 5 }}
                      outline
                      color="danger"
                      size="sm"
                      onClick={() => onPhotoRemoved(item.value)}
                    >
                      Bỏ chọn ảnh
                    </Button>
                  )}
                </FormGroup>
                {item.value === "photo" && (
                  <label style={{ color: "red" }}>
                    {error &&
                    !selectedPhotos[item.value] &&
                    item.value === "photo"
                      ? `Bạn vui lòng chọn ${item.label}`
                      : ""}
                  </label>
                )}
                {selectedPhotos && selectedPhotos[item.value] && (
                  <div className="portal-edit__img-container">
                    <img
                      key={item.value}
                      className="portal-edit__img"
                      src={URL.createObjectURL(selectedPhotos[item.value])}
                    />
                  </div>
                )}
              </Col>
            ))}
          </Row>
        </div>
        <div className="portal-section">
          <h2 className="portal-section-title">Thông tin liên hệ</h2>
          <br />
          <Row>
            <Col xs={12} sm={6}>
              <label>Người gửi tin</label>
              <Select
                options={contactRoleList}
                value={selectedContactRole}
                onChange={(selectedOption) => {
                  setSelectedContactRole(selectedOption);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && !selectedContactRole
                  ? "Bạn vui lòng chọn Người gửi tin"
                  : ""}
              </label>
            </Col>
            <Col xs={12} sm={6}>
              <label>Tên liên hệ</label>
              <Input
                value={contactName}
                onChange={(e) => {
                  setContactName(e.target.value);
                }}
              />
              <label style={{ color: "red", marginTop: 5 }}>
                {error && contactName === ""
                  ? "Bạn vui lòng nhập Tên liên hệ"
                  : ""}
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <label>Số điện thoại</label>
              <Input
                value={contactPhone}
                onChange={(e) => {
                  if (e.target.value.length > 12) {
                    return;
                  } else {
                    setContactPhone(e.target.value.replace(/[^0-9|.]/g, ""));
                  }
                }}
              />

              <label style={{ color: "red", marginTop: 5 }}>
                {error && contactPhone === ""
                  ? "Bạn vui lòng nhập Số điện thoại"
                  : ""}
              </label>
            </Col>
            <Col xs={12} sm={6}>
              <label>Email</label>
              <Input
                value={contactEmail}
                onChange={(e) => {
                  setContactEmail(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <label>Ghi chú</label>
              <Input
                value={description}
                type="textarea"
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />
            </Col>
          </Row>
        </div>
        <br />
        <Button
          style={{ backgroundColor: "#ea8024", borderColor: "#ea8024" }}
          disabled={isLoading}
          color="primary"
          size="lg"
          block
          onClick={onSendPress}
        >
          Gửi
        </Button>
        <br />
      </div>
    </Container>
  );
}

export default Portal;
